import { NoteId } from './note-id'
import type { DrawingElement } from 'features/Procedure/state/procedure.type'
import { formatDrawingNoteDisplay } from 'features/Procedure/utils/drawingDescription.utils'

export const procedureNotesTableColumns = [
  {
    title: '#ID',
    dataIndex: 'id',
    key: 'id',
    render: (id: string, element: DrawingElement) => <NoteId key={id} element={element} />,
  },
  {
    title: 'Note',
    dataIndex: 'description',
    key: 'description',
    render: (_: unknown, element: DrawingElement) => formatDrawingNoteDisplay(element.description),
  },
]
